module.exports = __webpack_public_path__ + "static/media/color_selected.d7267127.svg";